// extracted by mini-css-extract-plugin
module.exports = {"filter-btn":"OrdersTable_filter-btn_2jLma","filtered":"OrdersTable_filtered_2YofJ"};